import LinkAlertReducer from "../reducers/LinkAlertReducer";
import BaseAction from "./BaseAction";

class LinkAlertAction extends BaseAction {
  toggleLinkAlert = (row) => {
    const { linkedAlertData } = this.data();
    const isSelected = linkedAlertData.find((x) => x.alertId === row.alertId);
    if (isSelected) {
      const updatedData = linkedAlertData.filter(
        (x) => x.alertId !== row.alertId,
      );
      this.dispatch({
        linkedAlertData: updatedData,
      });
    } else {
      this.dispatch({
        linkedAlertData: [...linkedAlertData, row],
      });
    }
  };

  onOptionChange = (newData) => {
    this.dispatch({ linkedAlertData: newData });
  };

  removeSelectedAlerts = (alertToBeDeleted) => {
    const { linkedAlertData } = this.data();
    const updatedData = linkedAlertData.filter(
      (x) => !alertToBeDeleted.includes(x),
    );
    this.dispatch({ linkedAlertData: updatedData });
    return updatedData;
  };
}

const action = new LinkAlertAction(LinkAlertReducer);

export default action;
